module.exports = __webpack_public_path__ + "static/media/views.3c749dfc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/objects/other/views.svg
// module id = 863
// module chunks = 0